"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M21.989 6.219a8.4 8.4 0 0 1-2.392.657 4.17 4.17 0 0 0 1.831-2.305 8.4 8.4 0 0 1-2.646 1.011 4.165 4.165 0 0 0-7.096 3.8A11.83 11.83 0 0 1 3.101 5.03a4.14 4.14 0 0 0-.564 2.094c0 1.445.734 2.72 1.852 3.467a4.16 4.16 0 0 1-1.887-.521v.053a4.17 4.17 0 0 0 3.341 4.084 4.14 4.14 0 0 1-1.881.072 4.17 4.17 0 0 0 3.89 2.893 8.36 8.36 0 0 1-5.172 1.782q-.505 0-.994-.058a11.8 11.8 0 0 0 6.385 1.872c7.661 0 11.85-6.348 11.85-11.852q0-.27-.012-.538a8.5 8.5 0 0 0 2.079-2.156z"
}), 'Twitter');
//# sourceMappingURL=index.js.map